const SubThemes = {
  ADDING_SUB_THEME: 'subTheme/add',
  SUBTHEME_ARCHIVE_ACTION: 'subTheme/archive_action',
  SUBTHEME_UPDATE_SUCCESS: 'subTheme/update_success',
}

export default SubThemes;